import { render, staticRenderFns } from "./SwitchQuestion.vue?vue&type=template&id=37fce236&scoped=true"
import script from "./SwitchQuestion.vue?vue&type=script&lang=js"
export * from "./SwitchQuestion.vue?vue&type=script&lang=js"
import style0 from "./SwitchQuestion.vue?vue&type=style&index=0&id=37fce236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fce236",
  null
  
)

export default component.exports